import React, { useEffect, useRef } from 'react';

const UseCases = () => {
  const useCaseRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    useCaseRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      useCaseRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const useCases = [
    {
      icon: '🧾',
      title: 'Invoice Creation',
      description: 'Generate accurate invoices with correct VAT amounts for clients. Ensure compliance and professional billing by calculating tax-inclusive or tax-exclusive prices instantly.'
    },
    {
      icon: '🛒',
      title: 'E-Commerce Pricing',
      description: 'Set product prices with VAT included for online stores. Quickly determine the right selling price that accounts for tax while maintaining desired profit margins.'
    },
    {
      icon: '📊',
      title: 'Financial Reporting',
      description: 'Prepare accurate financial reports and tax returns. Calculate VAT amounts for multiple transactions efficiently, ensuring all records are precise and compliant.'
    },
    {
      icon: '💼',
      title: 'Business Expenses',
      description: 'Analyze receipts and invoices to extract VAT amounts. Understand the tax component of business expenses for accurate accounting and tax deduction purposes.'
    },
    {
      icon: '🌍',
      title: 'International Trade',
      description: 'Handle VAT calculations for cross-border transactions. Work with different VAT rates and currencies when dealing with international clients and suppliers.'
    },
    {
      icon: '💰',
      title: 'Budget Planning',
      description: 'Plan budgets and forecasts by accurately calculating tax implications. Understand the total cost including VAT for better financial planning and decision-making.'
    }
  ];

  return (
    <section className="use-cases-section">
      <div className="use-cases-container">
        <h2 className="section-title">Use Cases</h2>
        <p className="section-subtitle">Discover how VAT calculators streamline various business operations</p>

        <div className="features-grid">
          {useCases.map((useCase, index) => (
            <div
              key={useCase.title}
              className="feature-card"
              ref={el => useCaseRefs.current[index] = el}
            >
              <div className="feature-icon">{useCase.icon}</div>
              <h3>{useCase.title}</h3>
              <p>{useCase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
